const WORDS = ["Graphic Art", "Image to Video", "Videos", "Profile Pictures", "Cover Art", "Advertisements", "Websites", "Free Redo", "1–2 Day Reply"];

export const Marquee = () => (
  <div data-testid="marquee" className="relative py-8 border-y border-[var(--line)] bg-[var(--crypt)] overflow-hidden -rotate-1 scale-[1.02]">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
          {WORDS.map((w, i) => (
            <span key={w} className="flex items-center font-display text-3xl sm:text-5xl font-bold whitespace-nowrap px-8">
              <span className={i % 2 ? "italic text-[var(--ink-dim)] font-medium" : "text-gilded"}>{w}</span>
              <span className="ml-16 w-3 h-3 rotate-45 bg-[var(--blood)]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
